import type { CatalogueStockConfirmation } from "@/lib/catalogue-stock-confirmation";

/** Display only. No totals or stock mutations are constructed in the browser. */
export function StockDispositionPreview({ snapshot }: { snapshot?: CatalogueStockConfirmation | null }) {
  if (!snapshot) return <p role="alert" className="text-sm text-red-700">Reload this preview before authorizing a stock write-off.</p>;
  const rows = snapshot.balances.filter((row) => row.on_hand > 0);
  if (!rows.length) return null;
  return (
    <div className="border border-amber-200 rounded-lg overflow-hidden">
      <table className="w-full text-xs" aria-label="Exact stock proposed for write-off">
        <thead className="bg-amber-50 text-left"><tr><th className="px-3 py-2">Location</th><th className="px-3 py-2">SKU</th><th className="px-3 py-2 text-right">Units</th></tr></thead>
        <tbody>{rows.map((row) => <tr key={row.balance_id} className="border-t border-amber-100">
          <td className="px-3 py-2">{row.location_name}</td>
          <td className="px-3 py-2 font-mono">{row.sku ?? "Base product"}</td>
          <td className="px-3 py-2 text-right">{row.on_hand}</td>
        </tr>)}</tbody>
      </table>
      <p className="px-3 py-2 text-xs text-slate-600">Changed quantities, locations or variants require a new confirmation. Historical ledger entries are preserved.</p>
    </div>
  );
}
